import Vue from 'vue'
import VueRouter from 'vue-router'
import Students from '../components/student/students.vue'
import Student from '../components/student/student.vue'
import Programmes from '../components/programmes.vue'
import Lecturers from '../components/lecturer/lecturers.vue'
import Lessons from '../components/lesson/lessons.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/students',
    name: 'students',
    component: Students
  },
  {
    path: '/lecturers',
    name: 'lecturers',
    component: Lecturers
  },
  {
    path: '/lessons',
    name: 'lessons',
    component: Lessons
  },
  {
    path: '/student/:id',
    name: 'student',
    component: Student
  },
  {
    path: '/programmes/',
    name: 'programmes',
    component: Programmes
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
